import { FC, PropsWithChildren } from "react";
import { useSelectRows } from "../hooks/grid";
import { SelectRowsContext } from "../context";

const SelectRowsProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const selectRows = useSelectRows();
  return (
    <SelectRowsContext.Provider value={selectRows}>
      {children}
    </SelectRowsContext.Provider>
  );
};

export default SelectRowsProvider;
